//const api = "http://127.0.0.1:8000/api/";
const api = "https://grupobarraza.medikoala.com/api/";
export default api;